import React, { useState } from 'react'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import PropTypes from 'prop-types'
import { SignInInitialValues, signInValidationSchema } from 'constants/SignIn'
import Logo from 'assets/images/login/logo.svg'
import MailIcon from 'assets/images/login/mail.svg'
import LockIcon from 'assets/images/login/lock.svg'
import EyeIcon from 'assets/images/login/eye.svg'
import 'containers/sigin-in/SignIn.scss'

function SignInForm({ loginFormSubmitHandler }) {
  const [showPassword, setShowPassword] = useState(false)

  const handleSubmit = async (values, { setErrors, setSubmitting }) => {
    loginFormSubmitHandler(values, setErrors, setSubmitting)
  }

  return (
    <div className='login-card'>
      <div className='login-card-header'>
        <img className='login-logo' src={Logo} width={175} height={50} alt='XLR8' />
        <div className='login-card-copy'>
          <h1>Login to your account</h1>
          <p>Enter your details to login.</p>
        </div>
      </div>
      <div className='login-divider' />
      <Formik
        initialValues={SignInInitialValues}
        validationSchema={signInValidationSchema}
        onSubmit={handleSubmit}
      >
        <Form className='login-form'>
          <div className='login-field'>
            <label htmlFor='email'>
              Email Address<span>*</span>
            </label>
            <div className='login-input'>
              <img src={MailIcon} width={20} height={20} alt='' />
              <Field
                id='email'
                type='email'
                name='email'
                placeholder='hello@Ascend.com'
              />
            </div>
            <ErrorMessage name='email' component='p' className='error-message' />
          </div>
          <div className='login-field'>
            <label htmlFor='password'>
              Password<span>*</span>
            </label>
            <div className='login-input'>
              <img src={LockIcon} width={20} height={20} alt='' />
              <Field
                id='password'
                type={showPassword ? 'text' : 'password'}
                name='password'
                placeholder='••••••••••'
              />
              <button
                type='button'
                className='login-eye'
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                onClick={() => setShowPassword((visible) => !visible)}
              >
                <img src={EyeIcon} width={20} height={20} alt='' />
              </button>
            </div>
            <ErrorMessage
              name='password'
              component='p'
              className='error-message'
            />
          </div>
          <div className='login-support'>
            <a href='/?reset=1'>Forgot password?</a>
          </div>
          <button type='submit' className='login-submit'>
            Login
          </button>
        </Form>
      </Formik>
    </div>
  )
}

SignInForm.propTypes = {
  loginFormSubmitHandler: PropTypes.func.isRequired,
}

export default SignInForm
